import {
    SWITCH_TO_ANOTHER_GATEWAY,
    SWITCH_TO_ANOTHER_GATEWAY_REQUEST,
    VALIDATE_SWITCH_GATEWAY_ASSET,
    VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST,
    GET_GATEWAY_ASSETS_LIST_REQUEST,
    GET_GATEWAY_ASSETS_LIST,
    CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE,
    RESET_SWITCH_GATEWAY_VALIDATION_RESULT
} from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
export const getAssetSwitchToAnotherGatewayAction = getApiActionCreator(SWITCH_TO_ANOTHER_GATEWAY);
export const getAssetSwitchValidationGatewayAction = getApiActionCreator(VALIDATE_SWITCH_GATEWAY_ASSET);
export const getGatewayAssetsListAction = getApiActionCreator(GET_GATEWAY_ASSETS_LIST);
export const switchToAnotherGatewayRequest = (sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway, gatewayId, onResetAssetInfo) => ({
    type: SWITCH_TO_ANOTHER_GATEWAY_REQUEST,
    sourceAssetId,
    targetGatewayId,
    targetAssetId,
    isSwitchEgwToAnotherGateway,
    gatewayId,
    onResetAssetInfo
});
export const validateSwitchGatewayAssetRequest = (sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway) => ({
    type: VALIDATE_SWITCH_GATEWAY_ASSET_REQUEST,
    sourceAssetId,
    targetGatewayId,
    targetAssetId,
    isSwitchEgwToAnotherGateway
});

export const getGatewayAssetsListRequest = (gatewaySerialNumber) => ({
    type: GET_GATEWAY_ASSETS_LIST_REQUEST,
    gatewaySerialNumber
});
export const clearValidateSwitchGatewayAssetState = () => ({
    type: CLEAR_VALIDATE_SWITCH_GATEWAY_ASSET_STATE
});


export const resetSwitchGatewayValidationResult = () => ({
    type: RESET_SWITCH_GATEWAY_VALIDATION_RESULT,
});
